import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e15b1de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OEvento__Cabecalho" }
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  key: 0,
  class: "OEvento__Icones"
}
const _hoisted_4 = {
  key: 0,
  class: "OEvento__Icone pi pi-exclamation-triangle"
}
const _hoisted_5 = {
  key: 1,
  class: "OEvento__Icone pi pi-lock"
}
const _hoisted_6 = {
  key: 0,
  class: "OEvento__PeriodoEmHorarios",
  "data-testid": "OEvento__PeriodoEmHorarios"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_8 = {
  key: 1,
  class: "OEvento__InformacoesDeProfissionais",
  "data-testid": "OEvento__InformacoesDeProfissionais"
}
const _hoisted_9 = {
  key: 0,
  class: "OEvento__UmProfissional",
  "data-testid": "OEvento__UmProfissional"
}
const _hoisted_10 = {
  key: 1,
  class: "OEvento__VariosProfissionais",
  "data-testid": "OEvento__VariosProfissionais"
}
const _hoisted_11 = {
  key: 2,
  class: "OEvento__ContadorDeTempo",
  "data-testid": "OEvento__ContadorDeTempo"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "OEvento__ContadorIconeFinalizar" }, [
  /*#__PURE__*/_createElementVNode("em", { class: "pi pi-stop-circle" })
], -1))
const _hoisted_13 = { class: "OEvento__ContadorTempoCorrido" }
const _hoisted_14 = {
  key: 3,
  class: "OEvento__BarraDeProgresso",
  "data-testid": "OEvento__BarraDeProgresso"
}
const _hoisted_15 = { class: "OEvento__BarraDeFundo" }

import { IAvatar, OGrupoAvatar } from "@/components/Gerais"
  import {
    computed,
    withDefaults,
    ref,
    onMounted,
    onUnmounted,
    watch,
  } from "vue"
  import { usarFuncoesStrings } from "@/composable/UsarFuncoesStrings/usarFuncoesStrings"
  import Avatar from "primevue/avatar"
  import { FasesDaAtividade, ProblemaAtividade } from "@/repositorios/atividades/atividades.modelos"
  import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"
  import SessaoServico from "@/servicos/sessao.service"
  import { StatusEventoCalendario } from "@/store/atividades"
  import { useI18n } from "vue-i18n"

  interface Props {
    idUsuarioCriador?: string
    tipoDeAtividade: string
    profissionais: IAvatar[]
    faseDaAtividade: FasesDaAtividade
    inicio: Date
    fim: Date
    status: StatusEventoCalendario
    icone?: string
    problemas?: Array<{
      codigo: string
      justificativa: string
      problema: string
    }>
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OEvento',
  props: {
    idUsuarioCriador: null,
    tipoDeAtividade: null,
    profissionais: null,
    faseDaAtividade: null,
    inicio: null,
    fim: null,
    status: { default: "normal" },
    icone: null,
    problemas: null
  },
  setup(__props: any) {

const props = __props as { idUsuarioCriador?: string, tipoDeAtividade: string, profissionais: IAvatar[], faseDaAtividade: FasesDaAtividade, inicio: Date, fim: Date, status: StatusEventoCalendario, icone?: string, problemas?: Array<{
      codigo: string
      justificativa: string
      problema: string
    }> }

  const { t } = useI18n()

  

  const { pegarIniciais } = usarFuncoesStrings()
  const {
    pegarSomenteAsHoras,
    pegarTempoQuePassou,
    pegarProgressoEntreDataInicioEFim,
    pegarDuracaoEmMinutosEntreDataInicioEFim,
  } = usarDataHora()

  const temporizador = ref<string | null>("--:--:--")
  const eventoTravadoTooltip = ref("Atividade travada")
  const intervaloDaBarraDeProgresso = ref()
  const progressoNaAtividade = ref(0)
  const intervaloDoContador = ref()

  const statusDoEvento = computed(() => {
    return "OEvento--" + props.status
  })
  const faseDoEvento = computed(() => {
    return "OEvento--" + props.faseDaAtividade
  })

  const ehEvento = computed(() => {
    return props.status === "planejado" || props.status === "naoPlanejado"
  })

  const ehEventoTravado = computed(() => {
    return props.status === "travado"
  })

  const eventoEstaEmAndamento = computed(() => {
    return props.faseDaAtividade === "emAndamento"
  })

  const eventoEstaEmAndamentoEUsuarioLogadoEhCriador = computed(() => {
    const usuarioLogado = SessaoServico.coletarInformacoesDoUsuarioLogado()

    return (eventoEstaEmAndamento.value && props.idUsuarioCriador === usuarioLogado.id)
  })

  const eventoEmAndamentoPorUsuarioCriadorAteQuarentaCincoMinutos = computed(() => {
    const estaEmAndamentoPorUsuarioCriador = eventoEstaEmAndamentoEUsuarioLogadoEhCriador.value
    return (
      estaEmAndamentoPorUsuarioCriador &&
      duracaoTotalEmMinutos.value <= 45
    )
  })

  const horaDeInicio = computed(() => {
    return pegarSomenteAsHoras(props.inicio)
  })

  const horaDeFim = computed(() => {
    return pegarSomenteAsHoras(props.fim)
  })

  const duracaoTotalEmMinutos = computed(() => {
    return pegarDuracaoEmMinutosEntreDataInicioEFim(props.inicio, props.fim)
  })

  const progressoNaAtividadeEmAndamento = computed(() => {
    return pegarProgressoEntreDataInicioEFim(props.inicio, props.fim)
  })

  const problemaDoEvento = computed(() => {
    const possuiProblemas = props.problemas && props.problemas.length

    if (possuiProblemas) {
      return problemasComTextosTratados(props.problemas)[0].problema
    } else {
      return ''
    }
  })

  const temUmProfissional = computed(() => {
    return props.profissionais?.length === 1
  })

  const apartirDeCinquentaMinutos = computed(() => {
    const duracao = duracaoTotalEmMinutos.value

    return duracao >= 50
  })

  const aPartirDeVinteSeteMinutos = computed(() => {
    const duracao = duracaoTotalEmMinutos.value

    return duracao >= 27
  })

  const aPartirDeVinteSeisMinutos = computed(() => {
    const duracao = duracaoTotalEmMinutos.value

    return duracao >= 26
  })

  const estiloDeDuracao = computed(() => {
    const duracao = duracaoTotalEmMinutos.value
    const duracaoMinima = 11

    if (duracao <= duracaoMinima) {
      return "OEvento--AlturaMinima"
    }

    return ""
  })

  const problemasComTextosTratados = (
    problemasComTextosDoBackend: ProblemaAtividade[]
  ): ProblemaAtividade[] => {
    if (problemasComTextosDoBackend) {
      const problemasComTextosTratados = problemasComTextosDoBackend.map((problema) => {
        return {
          ...problema,
          problema: t(`problemas[${problema.codigo}].problema`)
        }
      })

      return problemasComTextosTratados
    }

    return []
  }

  const atualizarBarraDeProgressoPorIntervalo = (): void => {
    intervaloDaBarraDeProgresso.value = setInterval(() => {
      const progressoAtual = progressoNaAtividadeEmAndamento.value

      if (progressoAtual >= 100) {
        clearInterval(intervaloDaBarraDeProgresso.value)
      }

      progressoNaAtividade.value = progressoAtual
    }, 5000)
  }

  const atualizarCronometroDaAtividadePorIntervalo = (): void => {
    if (!aPartirDeVinteSeisMinutos.value) {
      return
    }


    intervaloDoContador.value = setInterval(() => {
      const { horas, minutos, segundos } = pegarTempoQuePassou(props.inicio)
      temporizador.value = `${horas}:${minutos}:${segundos}`
    }, 1000)
  }

  const limparIntervalos = (): void => {
    clearInterval(intervaloDaBarraDeProgresso.value)
    clearInterval(intervaloDoContador.value)
  }

  watch(
    () => props.faseDaAtividade,
    (novoEstado, estadoAntigo) => {
      if (novoEstado === "emAndamento" && estadoAntigo !== "emAndamento") {
        atualizarBarraDeProgressoPorIntervalo()
        atualizarCronometroDaAtividadePorIntervalo()
      } else if (
        novoEstado !== "emAndamento" &&
        estadoAntigo === "emAndamento"
      ) {
        limparIntervalos()
      }
    }
  )

  onMounted(() => {
    atualizarBarraDeProgressoPorIntervalo()
    atualizarCronometroDaAtividadePorIntervalo()
  })

  onUnmounted(() => {
    limparIntervalos()
  })

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["OEvento", [_unref(statusDoEvento), _unref(faseDoEvento), _unref(estiloDeDuracao)]]),
    "data-testid": "OEvento"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", {
        class: "OEvento__Titulo",
        title: __props.tipoDeAtividade
      }, _toDisplayString(__props.tipoDeAtividade), 9, _hoisted_2),
      (_unref(problemaDoEvento) || _unref(ehEventoTravado))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_unref(problemaDoEvento))
              ? _withDirectives((_openBlock(), _createElementBlock("em", _hoisted_4, null, 512)), [
                  [
                    _directive_tooltip,
                    _unref(problemaDoEvento),
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true),
            (_unref(ehEventoTravado))
              ? _withDirectives((_openBlock(), _createElementBlock("em", _hoisted_5, null, 512)), [
                  [
                    _directive_tooltip,
                    eventoTravadoTooltip.value,
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(aPartirDeVinteSeteMinutos) && !_unref(eventoEmAndamentoPorUsuarioCriadorAteQuarentaCincoMinutos))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString(_unref(horaDeInicio)), 1),
          _hoisted_7,
          _createElementVNode("span", null, _toDisplayString(_unref(horaDeFim)), 1)
        ]))
      : _createCommentVNode("", true),
    (
        __props.profissionais.length > 0 &&
          _unref(apartirDeCinquentaMinutos) &&
          !_unref(eventoEstaEmAndamentoEUsuarioLogadoEhCriador)
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_unref(temUmProfissional))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_unref(ehEvento))
                  ? (_openBlock(), _createBlock(_unref(OGrupoAvatar), {
                      key: 0,
                      avatares: __props.profissionais,
                      "limitar-quantidade-em": 6,
                      shape: "circle"
                    }, null, 8, ["avatares"]))
                  : (_openBlock(), _createBlock(_unref(Avatar), {
                      key: 1,
                      label: _unref(pegarIniciais)(__props.profissionais[0].nome),
                      shape: "circle"
                    }, null, 8, ["label"])),
                _createElementVNode("span", null, _toDisplayString(__props.profissionais[0].nome), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_unref(OGrupoAvatar), {
                  avatares: __props.profissionais,
                  "limitar-quantidade-em": 6,
                  shape: "circle"
                }, null, 8, ["avatares"])
              ]))
        ]))
      : _createCommentVNode("", true),
    (_unref(ehEvento) && _unref(eventoEstaEmAndamento) && _unref(aPartirDeVinteSeisMinutos))
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, _toDisplayString(temporizador.value), 1)
        ]))
      : _createCommentVNode("", true),
    (_unref(ehEvento) && _unref(eventoEstaEmAndamentoEUsuarioLogadoEhCriador))
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: "OEvento__BarraQueMove",
              style: _normalizeStyle({ width: progressoNaAtividade.value + '%' })
            }, null, 4)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})